// @flow
import React, { Component } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import SettingProfile from 'components/settings/SettingProfile/SettingProfile';
import { type UserData } from 'store/modules/user';
import { SettingsActions, UserActions } from 'store/actionCreators';
import { type Profile } from 'store/modules/profile';
import { type UploadInfo, type BizFileUploadInfo } from 'store/modules/settings';
import axios from 'axios';
import storage, { keys } from 'lib/storage';
import { escapeForUrl } from 'lib/common';

type Props = {
  user: ?UserData,
  profile: ?Profile,
  uploadInfo: ?UploadInfo,
  bizFileUploadInfo: ?BizFileUploadInfo,
};

class SettingProfileContainer extends Component<Props> {
  initialize = () => {
    const { user } = this.props;
    if (!user) return;
    SettingsActions.getProfile(user.username);
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.initialize();
    }
  }

  uploadFile = async (file: any) => {
    if (file.size > 1024 * 1024 * 10) return;
    const fileTypeRegex = /^image\/(.*?)/;
    if (!fileTypeRegex.test(file.type)) return;
    if (file.type.indexOf('gif') > 0) return;
    try {
      const filename = escapeForUrl(file.name);
      await SettingsActions.createThumbnailSignedUrl(filename);
      if (!this.props.uploadInfo) return;
      const { url, image_path: imagePath } = this.props.uploadInfo;
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        withCredentials: false,
        onUploadProgress: e => {
          if (window.nanobar) {
            window.nanobar.go((e.loaded / e.total) * 100);
          }
        },
      });
      const imageUrl = `https://images.cacheby.com/${imagePath}`;
      await SettingsActions.updateProfile({
        thumbnail: imageUrl,
      });
      await UserActions.checkUser();
      storage.set(keys.user, this.props.user);
    } catch (e) {
      console.log(e);
    }
  };

  uploadBizFile = async (file: any) => {
    try {
      const filename = escapeForUrl(file.name);
      await SettingsActions.createBizFileSignedUrl(filename);
      if (!this.props.bizFileUploadInfo) return;
      const { url, biz_file_path: bizFilePath } = this.props.bizFileUploadInfo;
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        withCredentials: false,
        onUploadProgress: e => {
          if (window.nanobar) {
            window.nanobar.go((e.loaded / e.total) * 100);
          }
        },
      });
      const bizFileUrl = `https://images.cacheby.com/${bizFilePath}`;
      await SettingsActions.updateProfile({
        bizFile: bizFileUrl,
      });
      await UserActions.checkUser();
      storage.set(keys.user, this.props.user);
    } catch (e) {
      console.log(e);
    }
  };

  onUploadThumbnail = () => {
    const upload = document.createElement('input');
    upload.type = 'file';
    upload.onchange = e => {
      if (!upload.files) return;
      const file = upload.files[0];
      this.uploadFile(file);
    };
    upload.click();
  };

  onUploadBizFile = () => {
    const upload = document.createElement('input');
    upload.type = 'file';
    upload.onchange = e => {
      if (!upload.files) return;
      const file = upload.files[0];
      this.uploadBizFile(file);
    };
    upload.click();
  };

  onUpdateProfile = async ({
    managerName,
    displayName,
    mobile,
    bizNumber,
  }: {
    managerName: string,
    displayName: string,
    mobile: string,
    bizNumber: string,
  }) => {
    await UserActions.updateUser({ managerName, displayName, mobile, bizNumber });
    return SettingsActions.updateProfile({ managerName, displayName, mobile, bizNumber });
  };

  render() {
    const { profile, user } = this.props;
    if (!profile) return null;
    return (
      <SettingProfile
        profile={profile}
        user={user}
        onUpdateProfile={this.onUpdateProfile}
        onUploadThumbnail={this.onUploadThumbnail}
        onUploadBizFile={this.onUploadBizFile}
      />
    );
  }
}

export default connect(
  ({ user, settings }: State) => ({
    user: user.user,
    profile: settings.profile,
    uploadInfo: settings.uploadInfo,
    bizFileUploadInfo: settings.bizFileUploadInfo,
  }),
  () => ({}),
)(SettingProfileContainer);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingProfileContainer.js